var global = require('../internals/global');
var nativeFunctionToString = require('../internals/function-to-string');
var WeakMap = global.WeakMap;
module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));